import { LocationNumbersService } from '../../../services'

const fetchCampaigns = async function (
  { commit, dispatch, state },
  config
) {
  commit('startLoading')

  try {
    const { locationId, payload } = config
    LocationNumbersService.getCampaigns(
      locationId,
      payload.companyId
    )

    await dispatch('fetchLocationTwilio', locationId)

    commit('stopLoading')
    return Promise.resolve(null)
  } catch (error) {
    commit('stopLoading')
    return Promise.reject(error)
  }
}

export default fetchCampaigns
